import {
  ECA_ACTIVITY_DETAILS_SUCCESS,
  ECA_ACTIVITY_EVENTS_PARTICIPANTS_SUCCESS,
  ECA_CLEAR_ACTIVITY_EVENTS_PARTICIPANTS,
  ECA_CREATE_PROGRAM_SUCCESS,
  ECA_UPDATE_PROGRAM_SUCCESS,
  ECA_DELETE_PROGRAM_SUCCESS,
  ECA_CREATE_ACTIVITY_SUCCESS,
  ECA_UPDATE_ACTIVITY_SUCCESS,
  ECA_DELETE_ACTIVITY_SUCCESS,
  ECA_ADD_ACTIVITY_PARTICIPANTS_SUCCESS,
  ECA_DELETE_ACTIVITY_PARTICIPANTS_SUCCESS,
  ECA_CREATE_EVENT_SUCCESS,
  ECA_UPDATE_EVENT_SUCCESS,
  ECA_DELETE_EVENT_SUCCESS,
  ECA_EVENT_DETAILS_SUCCESS,
  ECA_ADD_EVENT_PARTICIPANTS_SUCCESS,
  ECA_DELETE_EVENT_PARTICIPANTS_SUCCESS,
  ECA_LIST_PROGRAMS_SUCCESS,
  ECA_MODAL_HIDE_ACTIVITY_PARTICIPANTS,
  ECA_MODAL_HIDE_EDIT_ACTIVITY,
  ECA_MODAL_HIDE_EDIT_EVENT,
  ECA_MODAL_HIDE_EDIT_PROGRAM,
  ECA_MODAL_HIDE_EVENT_PARTICIPANTS,
  ECA_MODAL_SHOW_ACTIVITY_PARTICIPANTS,
  ECA_MODAL_SHOW_EDIT_ACTIVITY,
  ECA_MODAL_SHOW_EDIT_EVENT,
  ECA_MODAL_SHOW_EDIT_PROGRAM,
  ECA_MODAL_SHOW_EVENT_PARTICIPANTS,
  ECA_PROGRAM_DETAILS_SUCCESS,
  ECA_ADD_ACTIVITY_LEADS_SUCCESS,
  ECA_DELETE_ACTIVITY_LEADS_SUCCESS,
  ECA_FETCH_AND_SHOW_ACTIVITY_LEADS_SUCCESS,
  ECA_HIDE_AND_CLEAR_ACTIVITY_LEADS,
  ECA_ADD_EVENT_COORDINATORS_SUCCESS,
  ECA_DELETE_EVENT_COORDINATORS_SUCCESS,
  ECA_FETCH_AND_SHOW_EVENT_COORDINATORS_SUCCESS,
  ECA_HIDE_AND_CLEAR_EVENT_COORDINATORS,
  ECA_TODAY_EVENTS_SUCCESS,
  ECA_SEARCH_EVENTS_BY_PARTICPANTS_SUCCESS,
  CLEAR_FETCHED_EVENTS,
  ECA_SEARCH_EVENTS_BY_PARTICPANTS,
  ECA_EVENT_DETAILS,
  GET_EVENTS_HISTORY_SUCCESS,
  GET_EVENTS_HISTORY_FAILURE,
  SHOW_EVENTS_HISTORY_LOADER,
  HIDE_EVENTS_HISTORY_LOADER,
  GET_EVENT_HISTORY_TABS_SUCCESS,
  GET_EVENT_HISTORY_TABS_FAILURE,
  GET_EVENT_HISTORY_TAB_DATA,
  GET_EVENT_HISTORY_TAB_DATA_SUCCESS,
  GET_EVENT_HISTORY_TAB_DATA_FAILURE,
  CLEAR_EVENT_HISTORY_TAB_DATA,
} from 'constants/ActionTypes';

const INIT_STATE = {
  programs: [],
  program: null,
  activities: null,
  activity: null,
  modal: {
    showEditProgram: false,
    showEditActivity: false,
    showEditEvent: false,
    showActivityParticipants: false,
    showActivityLeads: false,
    showEventCoordinators: false,
    showEventParticipants: false,
  },
  eventsHistory: {
    items: [],
    pageCount: 1,
    loading: false,
    error: null,
  },
  eventHistoryTabs: [],
  eventHistoryTabsLoading: false,
  eventHistoryTabData: {}, // { [tabPath]: data }
  eventHistoryTabDataLoading: {}, // { [tabPath]: boolean }
};
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ECA_LIST_PROGRAMS_SUCCESS:
      return {
        ...state,
        programs: action.payload.programs,
      };
    case ECA_CREATE_PROGRAM_SUCCESS:
      return {
        ...state,
        programs: [...state.programs, action.payload.program],
      };
    case ECA_UPDATE_PROGRAM_SUCCESS:
      return {
        ...state,
        programs: state.programs.map(
          program => (program.id === action.payload.program.id ? action.payload.program : program),
        ),
      };
    case ECA_DELETE_PROGRAM_SUCCESS:
      return {
        ...state,
        programs: state.programs.filter(program => program.id !== action.payload.programId),
      };
    case ECA_PROGRAM_DETAILS_SUCCESS:
      return {
        ...state,
        program: action.payload.program,
        activities: action.payload.program.activities || [],
      };
    case ECA_CREATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        activities: [...state.activities, action.payload.activity],
      };
    case ECA_UPDATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        activities: state.activities.map(
          activity =>
            activity.id === action.payload.activity.id ? action.payload.activity : activity,
        ),
      };
    case ECA_DELETE_ACTIVITY_SUCCESS:
      return {
        ...state,
        activities: state.activities.filter(activity => activity.id !== action.payload.activityId),
      };
    case ECA_ADD_ACTIVITY_LEADS_SUCCESS:
    case ECA_DELETE_ACTIVITY_LEADS_SUCCESS:
      if (state.activity && state.activity.id === action.payload.activity.id) {
        return {
          ...state,
          activity: action.payload.activity,
          events: action.payload.activity.events || [],
        };
      }
      break;
    case ECA_FETCH_AND_SHOW_ACTIVITY_LEADS_SUCCESS:
      return {
        ...state,
        fetchedLeads: action.payload.activity.leads,
        modal: {
          ...state.modal,
          showActivityLeads: true,
        },
      };
    case ECA_HIDE_AND_CLEAR_ACTIVITY_LEADS:
      return {
        ...state,
        fetchedLeads: undefined,
        modal: {
          ...state.modal,
          showActivityLeads: false,
        },
      };
    case ECA_ADD_ACTIVITY_PARTICIPANTS_SUCCESS:
    case ECA_DELETE_ACTIVITY_PARTICIPANTS_SUCCESS:
    case ECA_ACTIVITY_DETAILS_SUCCESS:
      return {
        ...state,
        activity: action.payload.activity,
        events: action.payload.activity.events || [],
      };
    case ECA_ACTIVITY_EVENTS_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        activityAllEventsParticipants: action.payload.participants,
      };
    case ECA_CLEAR_ACTIVITY_EVENTS_PARTICIPANTS:
      return {
        ...state,
        activityAllEventsParticipants: undefined,
      };
    case ECA_CREATE_EVENT_SUCCESS:
      return {
        ...state,
        events: [...state.events, action.payload.event],
      };
    case ECA_UPDATE_EVENT_SUCCESS:
      if (action.payload.propagateStateEventDetails) {
        return {
          ...state,
          events: state.events.map(
            event => (event.id === action.payload.event.id ? action.payload.event : event),
          ),
          event: { ...(state.event || {}), ...action.payload.event },
        };
      }
      return {
        ...state,
        events: state.events.map(
          event => (event.id === action.payload.event.id ? action.payload.event : event),
        ),
      };
    case ECA_DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(event => event.id !== action.payload.eventId),
      };
    case ECA_ADD_EVENT_COORDINATORS_SUCCESS:
    case ECA_DELETE_EVENT_COORDINATORS_SUCCESS:
      if (state.event && state.event.id === action.payload.event.id) {
        return {
          ...state,
          event: action.payload.event,
        };
      }
      break;
    case ECA_FETCH_AND_SHOW_EVENT_COORDINATORS_SUCCESS:
      return {
        ...state,
        fetchedCoordinators: action.payload.event.coordinators,
        modal: {
          ...state.modal,
          showEventCoordinators: true,
        },
      };
    case ECA_HIDE_AND_CLEAR_EVENT_COORDINATORS:
      return {
        ...state,
        fetchedCoordinators: undefined,
        modal: {
          ...state.modal,
          showEventCoordinators: false,
        },
      };
    case ECA_EVENT_DETAILS:
      return {
        ...state,
        eventLoading: false,
      };
    case ECA_ADD_EVENT_PARTICIPANTS_SUCCESS:
    case ECA_DELETE_EVENT_PARTICIPANTS_SUCCESS:
    case ECA_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        event: action.payload.event,
        eventLoading: false,
      };
    case ECA_TODAY_EVENTS_SUCCESS:
      return {
        ...state,
        todayEvents: action.payload.todayEvents,
      };
    case ECA_SEARCH_EVENTS_BY_PARTICPANTS:
      return {
        ...state,
        searchEvent: true,
      };
    case ECA_SEARCH_EVENTS_BY_PARTICPANTS_SUCCESS:
      return {
        ...state,
        fetchedEvents: action.payload.fetchedEvents,
        searchEvent: false,
      };
    case CLEAR_FETCHED_EVENTS:
      return {
        ...state,
        searchEvent: false,
        fetchedEvents: undefined,
      };
    case ECA_MODAL_SHOW_EDIT_PROGRAM:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEditProgram: true,
        },
      };
    case ECA_MODAL_HIDE_EDIT_PROGRAM:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEditProgram: false,
        },
      };
    case ECA_MODAL_SHOW_EDIT_ACTIVITY:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEditActivity: true,
        },
      };
    case ECA_MODAL_HIDE_EDIT_ACTIVITY:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEditActivity: false,
        },
      };
    case ECA_MODAL_SHOW_EDIT_EVENT:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEditEvent: true,
        },
      };
    case ECA_MODAL_HIDE_EDIT_EVENT:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEditEvent: false,
        },
      };
    case ECA_MODAL_SHOW_ACTIVITY_PARTICIPANTS:
      return {
        ...state,
        modal: {
          ...state.modal,
          showActivityParticipants: true,
        },
      };
    case ECA_MODAL_HIDE_ACTIVITY_PARTICIPANTS:
      return {
        ...state,
        modal: {
          ...state.modal,
          showActivityParticipants: false,
        },
      };
    case ECA_MODAL_SHOW_EVENT_PARTICIPANTS:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEventParticipants: true,
        },
      };
    case ECA_MODAL_HIDE_EVENT_PARTICIPANTS:
      return {
        ...state,
        modal: {
          ...state.modal,
          showEventParticipants: false,
        },
      };

    // ECA History
    case GET_EVENTS_HISTORY_SUCCESS:
      return {
        ...state,
        eventsHistory: {
          ...state.eventsHistory,
          items: action.payload.items,
          pageCount: action.payload.pageCount,
          loading: false,
          error: null,
        },
      };
    case GET_EVENTS_HISTORY_FAILURE:
      return {
        ...state,
        eventsHistory: {
          ...state.eventsHistory,
          loading: false,
          error: action.payload.error,
        },
      };
    case SHOW_EVENTS_HISTORY_LOADER:
      return {
        ...state,
        eventsHistory: {
          ...state.eventsHistory,
          loading: true,
        },
      };
    case HIDE_EVENTS_HISTORY_LOADER:
      return {
        ...state,
        eventsHistory: {
          ...state.eventsHistory,
          loading: false,
        },
      };

    // ECA History Tabs
    case GET_EVENT_HISTORY_TABS_SUCCESS:
      return {
        ...state,
        eventHistoryTabs: action.payload.tabs,
        eventHistoryTabsLoading: false,
      };
    case GET_EVENT_HISTORY_TABS_FAILURE:
      return {
        ...state,
        eventHistoryTabsLoading: false,
      };

    // ECA History Tab Data
    case GET_EVENT_HISTORY_TAB_DATA:
      return {
        ...state,
        eventHistoryTabDataLoading: {
          ...state.eventHistoryTabDataLoading,
          [action.payload.tabPath]: true,
        },
      };
    case GET_EVENT_HISTORY_TAB_DATA_SUCCESS:
      return {
        ...state,
        eventHistoryTabData: {
          ...state.eventHistoryTabData,
          [action.payload.tabPath]: action.payload.data,
        },
        eventHistoryTabDataLoading: {
          ...state.eventHistoryTabDataLoading,
          [action.payload.tabPath]: false,
        },
      };
    case GET_EVENT_HISTORY_TAB_DATA_FAILURE:
      return {
        ...state,
        eventHistoryTabData: {
          ...state.eventHistoryTabData,
          [action.payload.tabPath]: { error: action.payload.error },
        },
        eventHistoryTabDataLoading: {
          ...state.eventHistoryTabDataLoading,
          [action.payload.tabPath]: false,
        },
      };

    case CLEAR_EVENT_HISTORY_TAB_DATA:
      return {
        ...state,
        eventHistoryTabData: {},
        eventHistoryTabDataLoading: {},
      };

    default:
  }
  return state;
};
